// extracted by mini-css-extract-plugin
export default {"outline":"level-icon_outline__CHKiv","outline--visible":"level-icon_outline--visible__rQaqI","background":"level-icon_background__SoAhB"};